"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResponsiveWrapper = exports.isMobile = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

// NOTE Merge to page-wrapper
var isMobile = function isMobile() {
  if (typeof window !== 'undefined') {
    return window.matchMedia('screen and (max-width: 768px)').matches;
  }

  return false;
};

exports.isMobile = isMobile;

var ResponsiveWrapper =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(ResponsiveWrapper, _React$Component);

  function ResponsiveWrapper() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, ResponsiveWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(ResponsiveWrapper)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isMobileCache", false);
    return _this;
  }

  (0, _createClass2["default"])(ResponsiveWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.isMobileCache = isMobile();

      if (typeof window !== 'undefined') {
        window.addEventListener('resize', function () {
          var newMobile = isMobile();

          if (newMobile === _this2.isMobileCache) {
            return;
          }

          _this2.isMobileCache = newMobile;

          _this2.forceUpdate();
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return _react["default"].createElement("div", {
        key: Date.now()
      }, children);
    }
  }]);
  return ResponsiveWrapper;
}(_react["default"].Component);

exports.ResponsiveWrapper = ResponsiveWrapper;